import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useAuth } from "@/lib/auth-context";
import { AppHeader } from "@/components/AppHeader";

export const Route = createFileRoute("/_app")({
  component: AppLayout,
});

function AppLayout() {
  const { session } = useAuth();
  const navigate = useNavigate();

  // No session? Bounce to root (the login page).
  // We don't gate on `loading` — the auth context resolves the session
  // synchronously from local storage on first paint, so if it's missing
  // here, it really is missing. The onAuthStateChange listener will catch
  // any late-arriving session and re-render.
  useEffect(() => {
    if (!session) {
      const redirectTo =
        typeof window !== "undefined"
          ? window.location.pathname + window.location.search
          : undefined;
      navigate({
        to: "/",
        search: { redirect: redirectTo && redirectTo !== "/" ? redirectTo : undefined },
        replace: true,
      });
    }
  }, [session, navigate]);

  // Don't render protected content until we have a session.
  // No global "Loading…" trophy — just render nothing for the brief moment
  // before the redirect fires.
  if (!session) return null;

  return (
    <>
      <AppHeader />
      <Outlet />
    </>
  );
}
